"use client";

import { motion } from "motion/react";
import type { ReactNode } from "react";

/** 滚动进入时上浮淡入。视口外不渲染动画，可达性下自动降级。 */
export function Reveal({
  children,
  delay = 0,
  y = 20,
  className = "",
  once = true,
}: {
  children: ReactNode;
  delay?: number;
  y?: number;
  className?: string;
  once?: boolean;
}) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, margin: "-80px" }}
      transition={{ duration: 0.7, delay, ease: [0.16, 1, 0.3, 1] }}
    >
      {children}
    </motion.div>
  );
}
